module.exports = __webpack_public_path__ + "static/logo-figma-bdafcb3f99009dcc72a3630b0da96c3a.png";